import {forwardRef, useContext} from 'react'
import {Dropdown} from 'react-bootstrap'
import {KTIcon} from '../../../../../_metronic/helpers'
import {showDeleteMessage, showMessage} from 'src/app/shared/Alerts'
import {TableBusiness} from '../../../generales_component/table/TableBusiness'
import {EntityByProcessContext} from '../EntityByProcessContext'
import { deleteCustomFromEntity } from 'src/app/services/external'

const CustomToggle = forwardRef(({onClick}: any, ref: any) => (
  <a
    ref={ref}
    href='#f'
    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
    title='Visualizar ficha'
    onClick={(e) => {
      e.preventDefault()
      onClick(e)
    }}
  >
    <KTIcon iconName='dots-square-vertical' className='fs-3' />
  </a>
))

const types = {
  text: 'Texto',
  number: 'Numero',
  date: 'Fecha',
  select: 'Lista desplegable',
  file: 'Archivo',
}

const headers = [
  {
    key: 'context',
    value: 'Seccion',
  },
  {
    key: 'label',
    value: 'Campo del colaborador',
  },
  {
    key: 'type',
    value: 'Tipo',
  },
  {
    key: 'assignmentCount',
    value: 'Cantidad de vinculos',
  },
  {
    key: 'actions',
    value: 'Acciones',
  },
]

export const EntityByProcessBody: React.FC = () => {
  const {data, setDetailField, setShowModal} = useContext(EntityByProcessContext)

  const handleDelete = async (id: string) => {
    console.log(id)
    const resp = await showDeleteMessage()
    if (resp.isConfirmed) {
      try {
        const deleteResponse = await deleteCustomFromEntity(id)
        if (deleteResponse.success) {
          showMessage('success', '¡Buen trabajo!', deleteResponse.message)
        } else {
          showMessage('error', 'Hubo un error', deleteResponse.message)
        }
      } catch (error) {
        showMessage('error', 'Error al eliminar', (error as Error).message)
      }
    }
  }

  return (
    <TableBusiness checkbox={{include: false}} headers={headers}>
      {data.map((context) =>
        context.fields.map((field) => {
          return (
            <tr key={field.id}>
              <td style={{paddingBlock: '5px', paddingLeft: '5px'}}>{context.label}</td>
              <td>{field.label}</td>
              <td>{types[field.type as keyof typeof types]}</td>
              <td>{field.assignmentCount}</td>
              <td className='text-end'>
                <Dropdown drop='up-centered'>
                  <Dropdown.Toggle className='btn btn-wd-dropdown btn-sm' children='Acciones' />
                  <Dropdown.Menu className='fs-7' style={{maxHeight: '200px', overflowY: 'auto'}}>
                    <Dropdown.Item
                      onClick={() => {
                        setDetailField({
                          field: field.label,
                          details: field?.assignmentDetails ?? [],
                        })
                        setShowModal(true)
                      }}
                    >
                      Ver detalle
                    </Dropdown.Item>
                    {field.assignmentCount === 0 && (
                      <Dropdown.Item onClick={() => handleDelete(field.identifier)}>
                        Eliminar
                      </Dropdown.Item>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              </td>
            </tr>
          )
        })
      )}
    </TableBusiness>
  )
}
